import { render, staticRenderFns } from "./LecturaNFC.vue?vue&type=template&id=33bdc0d8&scoped=true"
import script from "./LecturaNFC.vue?vue&type=script&lang=js"
export * from "./LecturaNFC.vue?vue&type=script&lang=js"
import style0 from "./LecturaNFC.vue?vue&type=style&index=0&id=33bdc0d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bdc0d8",
  null
  
)

export default component.exports